import connection from "../../../../api/config/connection";
import React from "react";
import Icon from "../../../Common/Icon";

export default {
  search: (input, callback, optionsSourceBaseUrl) => {
    const options = {
      method: "GET",
      url: `${optionsSourceBaseUrl}`,
      params: {
        q: input,
      },
    };

    connection
      .instance()(options)
      .then((response) => {
        try {
          const result = !response.data.result ? {} : response.data.result;
          const locations = (result.transit || [])
            .concat(result.general || [])
            .map((match) => {
              const name = `${match.name}${
                match.city && match.name.indexOf(match.city) === -1
                  ? `, ${match.city}`
                  : ""
              }${match.country ? `, ${match.country}` : ""}`;
              return {
                label: name,
                value: {
                  description: name,
                  type: match.type,
                  lat: match.location.latitude,
                  lng: match.location.longitude,
                },
              };
            });
          callback(locations);
        } catch (ex) {
          console.error(ex);
          callback();
        }
      })
      .catch((response) => {
        callback();
      });
  },

  convertSelectValueToValue: (selectValue, callback) => {
    callback(
      JSON.stringify({
        description: selectValue.value.description,
        lat: selectValue.value.lat,
        lng: selectValue.value.lng,
      })
    );
  },

  convertValueToSelectValue: (value) => {
    const selectValue = value
      ? {
          label: value.description,
          value: JSON.stringify(value),
        }
      : null;

    return selectValue;
  },

  components: (config) => {
    const locationTypes = Object.assign(
      {},
      {
        bus: "Bus",
        busStation: "Busstation",
        combiMetroTram: "Metro Tram",
        combiTramBus: "Tram Bus",
        elevator: "Lift",
        ferry: "Veerpont",
        ferryPort: "Veerponthaven",
        metro: "Metro",
        metroStation: "Metrostation",
        onstreetBus: "Bushalte",
        rail: "Trein",
        railStation: "Treinstation",
        tram: "Tram",
        taxi: "Taxi",
        tramStation: "Tramsstation",
        transitStation: "Station",
      },
      config.locationTypes
    );

    return {
      Option: (data) => {
        const type = data.value.type;
        const typeText = locationTypes[type] || "";
        const icon = `searchresult-transit-${typeText ? type : "other"}`;
        const className = `select__option ${
          data.isFocused || data.isSelected ? "select__option--is-focused" : ""
        }`;

        return (
          <div {...data.innerProps} className={className}>
            {icon ? (
              <Icon iconName={icon} className="select__option-icon" />
            ) : null}
            <div>
              {typeText ? (
                <span className="select__option-grayed">{typeText} </span>
              ) : (
                ""
              )}
              <span className="select__option-bold">{data.label}</span>
            </div>
          </div>
        );
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/SelectSources/GeoSearch.js